import { safeDefine } from "@breuni-ui/safe-define";
import { CarouselNavigationNext } from "@breuni-ui/carousel";

class RecoCarouselNaviNext extends CarouselNavigationNext {}
safeDefine("reco-carousel-navi-next", RecoCarouselNaviNext);
